const TOKEN_MAP = {
    primary: '--ac-primary',
    primaryText: '--ac-primary-text',
    surface: '--ac-surface',
    text: '--ac-text',
    radius: '--ac-radius',
    fontFamily: '--ac-font',
    colorScheme: null,
};
/**
 * Writes theme config onto a host element as CSS custom properties.
 * Everything downstream reads the variables, so a theme change is one
 * style write — no re-render, no cascade of props.
 */
export function applyTheme(host, theme) {
    for (const [key, variable] of Object.entries(TOKEN_MAP)) {
        if (!variable)
            continue;
        const value = theme[key];
        if (value)
            host.style.setProperty(variable, String(value));
    }
    if (theme.primary) {
        // Derived tokens the palette needs but the caller shouldn't have to supply.
        // The header tint and avatar glyph key off these, so a custom accent
        // recolours the whole panel coherently.
        host.style.setProperty('--ac-primary-hover', `color-mix(in srgb, ${theme.primary} 82%, #000)`);
        host.style.setProperty('--ac-primary-soft', `color-mix(in srgb, ${theme.primary} 10%, transparent)`);
    }
    const scheme = theme.colorScheme ?? 'auto';
    host.classList.remove('ac-theme-light', 'ac-theme-dark', 'ac-theme-auto');
    host.classList.add(`ac-theme-${scheme}`);
    host.style.colorScheme = scheme === 'auto' ? 'light dark' : scheme;
}
